import { render, staticRenderFns } from "./release_list.vue?vue&type=template&id=6cb6e404&scoped=true"
import script from "./release_list.vue?vue&type=script&lang=js"
export * from "./release_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb6e404",
  null
  
)

export default component.exports